/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';
import {replacePXinStringWithEM} from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORM : FIELD : FANCYRADIO : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    fancyradio: {
        position: 'relative',
        cursor: 'pointer',
        lineHeight: pxToEm(24),
        fontSize: pxToEm(16),
        margin: `${pxToEm(12)} 0px`,
        color: props => props.disabled ?  'rgba(6, 43, 117, 0.1)' : 'rgba(6, 43, 117, 0.50)',
        '& .fancyradiospan': {
            position: 'relative',
            display: 'block',
            float: 'left',
            marginRight: pxToEm(10),
            width: pxToEm(25),
            height: pxToEm(25),
            background: '#fafbfc',
            border: replacePXinStringWithEM('2px solid #eef2f6'),
            borderRadius: '100%',
            '&:after':{
                content: '""',
                position: 'absolute',
                top: pxToEm(3),
                left: pxToEm(3),
                width: pxToEm(15),
                height: pxToEm(15),
                borderRadius: '100%',
                background: '#1494f4',
                transform: 'scale(0)',
                transition: 'all 0.2s ease',
                opacity: 0.08,
                pointerEvents: 'none'
            }
        },
        '& .radio': {
            display: 'none'
        },
        '& .radio:checked + .fancyradiospan' : {
            borderColor: '#1494f4',
            '&:after': {
                transform: 'scale(1)',
                transition: 'all 0.2s cubic-bezier(0.35, 0.9, 0.4, 0.9)',
                opacity: 1
            }
        },
        '& .radio:disabled + .fancyradiospan' : {
            pointerEvents: 'none',
            opacity: 0.5,
         }
    }
});